define('views/dropdownlist',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DropdownList = void 0;
    var DropdownList = /** @class */ (function () {
        function DropdownList(options) {
            var _this = this;
            this.dropdown = document.createElement("div");
            this.open = false;
            this.activeIndex = -1;
            this.dropdown.classList.add("dropdown-items");
            this.options = options;
            // Setup keyboard navigation
            options.input.addEventListener("keydown", function (e) { return _this.onKeyDown(e); });
            // Close list on click anywhere
            document.addEventListener("click", function (e) {
                if (_this.open && !options.input.parentNode.contains(e.target)) {
                    _this.close();
                }
            });
        }
        // Update the view with new items
        DropdownList.prototype.update = function (items) {
            var _this = this;
            if (!this.open) {
                // append the dropdown element as a child of the dropdown container
                this.options.input.parentNode.appendChild(this.dropdown);
                this.open = true;
            }
            // Clear items
            this.dropdown.innerText = "";
            this.active = undefined;
            this.activeIndex = -1;
            // Add items
            items.forEach(function (item, index) {
                _this.dropdown.appendChild(_this.createItem(item, index));
            });
            if (items.length === 0) {
                this.close();
            }
        };
        // Close dropdown list
        DropdownList.prototype.close = function () {
            if (this.open) {
                this.dropdown.parentNode.removeChild(this.dropdown);
                this.open = false;
            }
        };
        DropdownList.prototype.createItem = function (item, index) {
            var _this = this;
            var div = document.createElement("div");
            div.innerText = this.options.display(item);
            // Make active on hover
            div.addEventListener("mouseover", function () {
                _this.activeIndex = index;
                _this.updateActive();
            });
            div.addEventListener("click", function () {
                _this.options.onClick(item);
                // close dropdown
                _this.close();
            });
            return div;
        };
        DropdownList.prototype.onKeyDown = function (e) {
            if (!this.dropdown)
                return;
            if (e.keyCode === 40) { // Key down
                this.activeIndex++;
                this.updateActive();
            }
            else if (e.keyCode === 38) { // Key up
                this.activeIndex--;
                this.updateActive();
            }
            else if (e.keyCode === 13) { // Enter
                if (this.activeIndex > -1) {
                    // Prevent form submit
                    e.preventDefault();
                    // and simulate a click on the "active" item
                    if (this.active)
                        this.active.click();
                }
            }
        };
        // Classify current item as "active"
        DropdownList.prototype.updateActive = function () {
            // Removing existing "active" class
            if (this.active) {
                this.active.classList.remove("dropdown-item-active");
            }
            var divs = Array.from(this.dropdown.getElementsByTagName("div"));
            if (this.activeIndex >= divs.length)
                this.activeIndex = 0;
            if (this.activeIndex < 0)
                this.activeIndex = divs.length - 1;
            this.active = divs[this.activeIndex];
            // Add class
            this.active.classList.add("dropdown-item-active");
            // Scroll to active if needed
            var offsetTop = this.active.offsetTop - this.dropdown.scrollTop;
            if (offsetTop < 0) {
                // Scroll up
                this.dropdown.scrollTo(0, this.active.offsetTop);
            }
            var offsetBottom = offsetTop + this.active.offsetHeight;
            if (this.dropdown.offsetHeight < offsetBottom) {
                // Scroll down
                var delta = offsetBottom - this.dropdown.offsetHeight;
                this.dropdown.scrollTo(0, this.dropdown.scrollTop + delta);
            }
        };
        return DropdownList;
    }());
    exports.DropdownList = DropdownList;
});
//# sourceMappingURL=/assets/javascripts/views/dropdownlist.js.map;
